import Keycloak from 'keycloak-js'
import { forceLogout, setSession } from 'src/auth/context/jwt/utils'
import { paths } from 'src/routes/paths'

const { REACT_APP_KEYCLOAK_HOST } = process.env

const settings = {
  url: REACT_APP_KEYCLOAK_HOST,
  realm: 'DigitalLibrary',
  clientId: 'frontend',
  onLoad: 'check-sso',
  responseType: 'code',
  responseMode: 'query',
}

const _kc = new Keycloak(settings)

_kc.onAuthSuccess = () => {
  setSession(getToken())
}

_kc.onAuthError = () => {
  forceLogout()
}

_kc.onTokenExpired = () => {
  _kc
    .updateToken(5)
    .then(() => {})
    .catch(() => forceLogout())
}

_kc.onAuthRefreshSuccess = () => {
  setSession(getToken())
}

_kc.onAuthRefreshError = () => {
  forceLogout()
}

const initKeycloak = (onAuthenticatedCallback) => {
  _kc
    .init({
      scope: 'openid profile',
      onLoad: 'check-sso',
      checkLoginIframe: true,
      pkceMethod: 'S256',
      responseMode: 'query',
    })
    .then(() => {
      onAuthenticatedCallback()
    })
    .catch(console.error)
}

const doLogin = () => _kc.login({ redirectUri: window.location.origin + paths.app.dashboard })

const doLogout = () => _kc.logout({ redirectUri: window.location.origin + paths.login })

const getToken = () => _kc.token

const getTokenParsed = () => _kc.tokenParsed

const isLoggedIn = () => !!_kc.token

const updateToken = (successCallback) => _kc.updateToken(5).then(successCallback).catch(doLogin)

const getUsername = () => _kc.tokenParsed?.preferred_username

const hasRole = (roles) => roles.some((role) => _kc.hasRealmRole(role))

const keycloak = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  getTokenParsed,
  updateToken,
  getUsername,
  hasRole,
}

export default keycloak
